var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '../../themes';
import { cx } from '../../utils/dom';
import AccessoryWrapper from '../AccessoryWrapper';
import Spinner from '../Spinner';
import { Typography } from '../Typography';
import { customButtonProps } from './modifiers';
import * as S from './styles';
export var Button = forwardRef(function (props, ref) {
    var _a;
    var theme = useTheme();
    var buttonStyleProps = customButtonProps(__assign(__assign({}, props), { theme: theme }));
    return (
    // @ts-ignore
    _jsx(S.Button, __assign({ ref: ref, className: cx(props === null || props === void 0 ? void 0 : props.className), disabled: (props === null || props === void 0 ? void 0 : props.disabled) || (props === null || props === void 0 ? void 0 : props.isLoading) }, props, buttonStyleProps, { children: _jsx(ButtonContent, __assign({}, props, { spinnerColor: (_a = props.spinnerColor) !== null && _a !== void 0 ? _a : buttonStyleProps.labelColor })) })));
});
function ButtonContent(_a) {
    var iconLeft = _a.iconLeft, iconRight = _a.iconRight, children = _a.children, devTypographyProps = _a.typographyProps, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, spinnerColor = _a.spinnerColor, props = __rest(_a, ["iconLeft", "iconRight", "children", "typographyProps", "isLoading", "spinnerColor"]);
    var spacing = useTheme().spacing;
    var typographyProps = __assign({ type: 'p2', fontWeight: 'bold' }, devTypographyProps);
    var labelPadding = function () {
        if (props.isFullWidth) {
            return {
                justifyContent: "center",
                flex: 1,
                marginLeft: iconLeft ? -spacing.xs : 0,
                marginRight: iconRight ? -spacing.xs : 0,
            };
        }
        return {
            paddingLeft: iconLeft ? spacing.nano : spacing.xxs,
            paddingRight: iconRight ? spacing.nano : spacing.xxs,
        };
    };
    var visibility = isLoading ? 'hidden' : 'visible';
    return (_jsxs(_Fragment, { children: [iconLeft && !iconRight && (_jsx(AccessoryWrapper, __assign({ mLeft: "xxxs", "data-testid": "iconLeft", style: { visibility: visibility } }, { children: iconLeft }))), _jsx("div", __assign({ style: __assign(__assign({}, labelPadding()), { width: '100%' }) }, { children: _jsxs(Typography, __assign({ textAlign: "center" }, typographyProps, { children: [_jsx("span", __assign({ style: { visibility: visibility } }, { children: children })), isLoading && _jsx(Spinner, { isCentered: true, color: spinnerColor })] })) })), iconRight && !iconLeft && (_jsx(AccessoryWrapper, __assign({ mRight: "xxxs", "data-testid": "iconRight", style: { visibility: visibility } }, { children: iconRight })))] }));
}
